import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "rnb-seasonal-pricing"
    }}>{`RnB Seasonal Pricing`}</h1>
    <p>{`The Seasonal pricing add-on allows you to charge promotional/seasonal pricing for specific date range of any rental product. This enables admin to configure pricing very easily based on different criteria. This is a simple and easy to use add-on perfect for your business if your price changes for peak and off-peak season. If the rental duration falls within multiple seasons then the system will not count seasonal pricing.`}</p>
    <h3 {...{
      "id": "requirements"
    }}>{`*Requirements:`}</h3>
    <p>{`You must have the following plugin installed`}</p>
    <p><a parentName="p" {...{
        "href": "https://codecanyon.net/item/rnb-woocommerce-rental-booking-system/14835145"
      }}>{`RnB - WooCommerce plugin`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://wordpress.org/plugins/woocommerce/"
      }}>{`WooCommerce plugin`}</a></p>
    <h3 {...{
      "id": "support"
    }}>{`Support:`}</h3>
    <p><a parentName="p" {...{
        "href": "https://redqsupport.ticksy.com/"
      }}>{`Customer Support`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      